import moment from "moment";
const utils = {
  year() {
    return moment(new Date()).format("YYYY");
  },
  toRupiah(nominal) {
    return nominal.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.");
  },

  formattedPrice(nominal) {
    return new Intl.NumberFormat("id-ID").format(nominal);
  },

  toRupiahString(nominal) {
    return nominal.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.", 0);
  },
  toDate(tanggal) {
    return moment(String(tanggal)).format("DD-MM-YYYY");
  },
  toDateStringMount(tanggal) {
    return moment(String(tanggal)).format("DD MMM YYYY");
  },
  toDateTime(tanggal) {
    return moment(String(tanggal)).format("DD-MM-YYYY HH:mm");
  },
  toDateTimeFormat(value, format = "DD-MM-YYYY HH:mm") {
    if (value) {
      return moment(String(value)).format(format);
    }
  },
  formatTime(value) {
    if (value) {
      return moment(String(value), "HH:mm").format("HH:mm");
    }
  },
  toQueryString(params) {
    return new URLSearchParams(params).toString();
  },
};
export default utils;
